<template>
    <div class="publication-inform">
        <time class="publication-date" v-if="result.date">
            {{ result.date }}
        </time>
        <time
            v-if="screenWidth >= 768"
            class="publication-date"
        >
            {{ result.readTime }}
        </time>
        <address class="publication-author">
            <AAvatar width="25" :src="result.author.picture.src" :alt="result.author.picture.alt" :title="result.author.picture.title" class="mr-3"/>
            <span> {{ result.author.name }}</span>
        </address>
    </div>
</template>

<script>
import {AAvatar} from "../../ui";

export default {
    name: 'PublicationInform',
    props: ['result'],
    components: {AAvatar}
}
</script>

<style lang="scss" scoped>
.publication-inform {
    display: flex;
    padding: 25px 0;
}

.publication-date {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161515;
    padding: 6px 10px;
    border: 1px solid #E9EBED;
    border-radius: 6px;

    &:not(:last-of-type) {
        margin-right: 9px;
    }
}

.publication-author {
    display: flex;
    align-items: center;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #252425;
    margin-left: 20px;
    @include mobile {
        margin-left: 14px;
    }

    &__image {
        display: block;
        max-width: 22px;
        margin-right: 8px;
    }
}
</style>